import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { AfterViewInit, Injector } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Transaction } from '@models/transaction';
import { TransactionDto } from '@dto/transactionDto';
import { TransactionSuccess } from '@enums/transaction-success.enum';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionsService } from '@services/entity/transactions.service';
import { FilesService } from '@services/files/files.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import { Chart, ChartConfiguration, ChartData, registerables } from 'chart.js';
import {
  addMinutes, subMinutes,
  setSeconds, setMilliseconds, getMinutes, format
} from 'date-fns'

import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TransactionMeterValuesChartData } from '@models/TransactionMeterValuesChartData';
import { Time } from '@angular/common';

@Component({
  selector: 'app-details-transaction-dialog-content',
  templateUrl: './details-transaction-dialog-content.component.html',
  styleUrls: ['./details-transaction-dialog-content.component.scss']
})
export class DetailsTransactionDialogContentComponent extends AbstractDialogContent implements OnInit, AfterViewInit {

  public className = 'DetailsTransactionDialogContentComponent';

  @ViewChild('detailsTransaction') detailsTransaction;

  public entity: TransactionDto;

  public customerId: number;

  public fileExists: boolean;

  chartIsLoading = false;
  public chart: Chart;
  public canvas: any;
  public ctx: any;

  constructor(
    public activeModal: NgbActiveModal,
    private filesService: FilesService,
    private transactionsService: TransactionsService,
    public toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }


  ngOnInit() {
    super.ngOnInit();


  }

  ngAfterViewInit(): void {
  }



  async onEntityLoadedEvent(entity: TransactionDto) {
    if (!entity) return
    this.entity = entity;

    this.getTransactionMeterValuesChartDatas();

    this.entity.successMessage = TransactionSuccess[entity.success];
    this.checkIfFileExists();

    if (!this.entity?.meterAmount) {
      this.transactionsService.getKwhOfRunningTransaction(entity.transactionId).subscribe(kWh=>{
        this.entity.meterAmount = kWh;
      })
    }
  }

  getTransactionMeterValuesChartDatas(): Promise<TransactionMeterValuesChartData[] | null> {
    return new Promise((resolve, reject) => {
      this.transactionsService.getTransactionMeterValuesChartDatas(this.entity.transactionId).subscribe(
        tmvcd => {
          if (tmvcd?.length) {
            document.getElementById('MeterValuesChart').style.display = 'block';
            this.createChartData(tmvcd);
            resolve(tmvcd);
          } else {
            document.getElementById('MeterValuesChart').style.display = 'none';
            resolve(null);
          }
        },
        error => {
          console.error('Fehler beim Abrufen oder Verarbeiten der Daten:', error);
          document.getElementById('MeterValuesChart').style.display = 'none';
          reject(error);
        }
      );
    });
  }

  setMeterAmountByChartDatas() {

  }




  checkIfFileExists() {
    var fileName = 'signedMeterValues/' + this.entity.id + '-signedMeterValue.xml';

    this.filesService.fileExists(fileName).subscribe(result => {
      this.fileExists = result;
    })
  }

  downloadSignedMeterValues() {
    if (this.fileExists) {
      var fileName = 'signedMeterValues/' + this.entity.id + '-signedMeterValue.xml';
      var downloadFileName = this.entity.id + '-signedMeterValue.xml';
      this.filesService.download(fileName, downloadFileName);
      this.toastService.success('Die signierte Datei wird erfolgreich heruntergeladen!')
      this.activeModal.close()
    }
  }


  createChartData(dataPoints: TransactionMeterValuesChartData[]) {
    dataPoints.forEach(item => {
      item.timestamp = new Date(item.timestamp);
    });

    dataPoints.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());

    const transformedDataPoints = dataPoints.map(point => {

      let timestamp = point.timestamp;
      if (!(timestamp instanceof Date)) {
        timestamp = new Date(timestamp);
      }

      return {
        x: timestamp,
        y: point.powerInkW
      };
    });

    this.createChart(transformedDataPoints);
  }

  createChart(dataPoints: { x: Date, y: number }[]): void {
    if (this.chart) {
      this.chart.destroy();
    }

    // runde nach unten auf volle 15 min
    const floorQuarter = d =>
      subMinutes(setMilliseconds(setSeconds(d, 0), 0), getMinutes(d) % 15);

    // runde nach oben auf volle 15 min
    const ceilQuarter = d => {
      const r = getMinutes(d) % 15;
      return r === 0
        ? setMilliseconds(setSeconds(d, 0), 0)
        : addMinutes(setMilliseconds(setSeconds(d, 0), 0), 15 - r);
    };

    const minTick = Number(floorQuarter(new Date(dataPoints[0].x)));
    const maxTick = Number(ceilQuarter(new Date(dataPoints[dataPoints.length - 1].x)));


    const ctx = document.getElementById('distribution-chart-canvas') as HTMLCanvasElement;

    const chartData: ChartData<'line', { x: Date, y: number }[]> = {
      datasets: [
        {
          data: dataPoints,
          borderColor: 'rgba(7, 181, 245, 1)',
          backgroundColor: 'rgba(75, 192, 192, 0.2)',
          fill: false,
          //tension: 0.2,
          //cubicInterpolationMode: 'monotone',
          pointRadius: 0 // Make data points invisible

        }
      ]
    };

    const config: ChartConfiguration<'line', { x: Date, y: number }[]> = {
      type: 'line',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
              type: 'time',           // Date-Fns-Adapter erledigt das Parsen
              min: minTick,
              max: maxTick,

              /* 15-min-Raster */
              time: {
                unit: 'minute',
                stepSize: 15,         // ◄◄  V3: im time-Block!
                displayFormats: { minute: 'HH:mm' }
              },

              ticks: {
                autoSkip:true,  // Chart JS blendet Labels aus, falls es eng wird
                //callback: v => format(v, 'HH:mm')  // hübsches Label
              },

              bounds: 'ticks'          // Skala endet exakt auf Tick-Werten
            },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Leistung in kW'
            }
          }
        },
        plugins: {
          legend: {
            display: false // Disable the legend
          }
        },
      }
    };

    this.chart = new Chart(ctx, config as any);
  }

  updateChart(newDataPoints: { x: Date, y: number }[]): void {
    this.createChart(newDataPoints);
  }












}
